import { ComponentProps, FC } from 'react';

import { LoaderCircleIcon } from '@/assets/icons';

type LoaderProps = ComponentProps<'div'>;

export const Loader: FC<LoaderProps> = ({ ...props }) => {
  return (
    <div
      {...props}
      className="flex justify-center items-center h-full"
      role="status"
      aria-live="polite"
    >
      <LoaderCircleIcon className="animate-spin text-blue-500" width={40} height={40} />
      <span className="sr-only">Loading...</span>
    </div>
  );
};
